export default __webpack_public_path__ + "static/media/seven-form.9fa876d5.svg";